import { Environments } from "../environment/types";
import { MonitoringConfiguration } from "./monitoring-types";

export const configureErrorSamplingRate = (environment: Environments, errorSamplingRate: MonitoringConfiguration["errorSamplingRate"]) => {
    let result = 1.0;

    switch (environment) {
        case "local":
            result = errorSamplingRate?.local ?? 0.0;
            break;
        case "dev":
            result = errorSamplingRate?.dev ?? 0.1;
            break;
        case "uat":
            result = errorSamplingRate?.uat ?? 1.0;
            break;
        case "prod":
            result = errorSamplingRate?.prod ?? 1.0;
            break;
    }
    return result;
};